const SERVICE_DATA = {
    heading: "Our Services",
    
    description: "We craft digital, graphic and dimensional thinking, to create category leading brand experiences that have meaning and add a value for our clients.",
    services_list: [{
            key: 1,
            label: "Digital Design",
            text: "Choose from 500+ customizable website templates that are built to meet your business needs.",
            icon: "pe-7s-diamond"
        },
        {
            key: 2,
            label: "Total Design Freedom",
            text: "Start from scratch or choose from over 500 designer-made templates that you can fully ",
            icon: "pe-7s-display2"
        },
        {
            key: 3,
            label: "Invoices",
            text: "Allow your customers to download copies of their invoices.will even receive an email with their monthly or yearly invoices.",
            icon: "pe-7s-display2"
        },
        {
            key: 4,
            label: "Subscriptions",
            text: "allows you to define monthly and yearly subscription plans in a simple configuration file. ",
            icon: "pe-7s-display2"
        },
        {
            key: 5,
            label: "Perfect Toolbox",
            text: "Various toolbars are integrated to make the website function better",
            icon: "pe-7s-tools"
        },
        {
            key: 6,
            label: "Easy Upgrades",
            text: "Very convenient upgrade, update your content anytime,anywhere",
            icon: "pe-7s-timer"
        },
    ]
};

const FEATURES_DATA = {
    title: 'A digital web design studio creating modern & engaging online',
    text: 'Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.',
    feature_list: [
        'We put a lot of effort in design.',
        'The most important ingredient of successful website.',
        'Submit Your Orgnization.'
    ]
};

const WEBSITE_DESCRIPTION = {
    title: 'Build your dream website today',
    text: 'But nothing the copy said could convince her and so it didn’t take long until a few insidious Copy Writers ambushed her.',
    buttontext: 'View Plan & Pricing'
};

const PRICING_DATA = {
    title: 'Our Pricing',
    description: 'From start to shipped.',
    pricing_list: [
        {
            title: 'Economy',
            price: '$999',
            bandwidth: '1GB',
            onlinespace: '50MB',
            support: 'No',
            domain: 1,
            hiddenfees: 'No'
        },
        {
            title: 'Delux',
            price: '$1990',
            bandwidth: '10GB',
            onlinespace: '500MB',
            support: 'Yes',
            domain: 10,
            hiddenfees: 'No'
        },
        {
            title: 'Unlimate',
            price: '$2999',
            bandwidth: '100GB',
            space: '2 GB',
            support: 'Yes',
            domain: 'Unlimited',
            hiddenfees: 'No'
        }
    ]
};

const TEAM_DATA = {
        title: 'Behind The People',
        description: 'It is a long established fact that create category leading brand experiences a reader will be distracted by the readable content of a page when looking at its layout.',
        team_list: [
            {
                profile: '/images/team/img-1.jpg',
                name: 'Frank Johnson',
                designation: 'CEO'
            },
            {
                profile: '/images/team/img-2.jpg',
                name: 'Elaine Stclair',
                designation: 'Designer'
            },
            {
                profile: '/images/team/img-3.jpg',
                name: 'Wanda Arthur',
                designation: 'Developer'
            },
            {
                profile: '/images/team/img-4.jpg',
                name: 'Joshua Stemple',
                designation: 'Manager'
            }
        ]
}

const TESATIMONIAL_DATA = {
    title :"What they've said",
    description: "The Big Oxmox advised her not to do so, because there were thousands of bad Commas, wild Question Marks and devious Semikoli.",
    testimonial_list: [
        {
            profile: 'images/testimonials/user-1.jpg',
            description: "I feel confident imposing change on myself. It's a lot more fun progressing than looking back. That's why I ultricies enim at malesuada nibh diam on tortor neaded to throw curve balls.",
            name: 'Dennis Williams - ',
            text: 'Charleston'
        },
        {
            profile: 'images/testimonials/user-2.jpg',
            description: "Our task must be to free ourselves by widening our circle of compassion to embrace all living creatures and the whole of quis consectetur nunc sit amet semper justo.nature and its beauty.",
            name: 'Laurie Bell - ',
            text: 'Worcester'
        },
        {
            profile: 'images/testimonials/user-3.jpg',
            description: "I've learned that people will forget what you said, people will forget what you did,but people will never forget how donec in efficitur lectus, nec lobortis metus you made them feel.",
            name: 'Howard Kelley - ',
            text: 'Lynchburg'
        }
    ]
}

const GET_STARTED = {
    newtitle: "Let's Get Started",
    newtext: 'Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.',
    newbuttontext: 'Get Started'
};

const BLOG_DATA = {
    title :'Latest News',
    description: 'Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean class at a euismod mus luctus quam.',
    blog_list:[
        {
            image: 'images/blog/img-1.jpg',
            text: 'UI & UX Design',
            title: 'Doing a cross country road trip',
            subtext: 'She packed her seven versalia, put her initial into the belt and made herself on the way..'
        },
        {
            image: 'images/blog/img-2.jpg',
            text: 'Digital Marketing',
            title: 'New exhibition at our Museum',
            subtext: 'Pityful a rethoric question ran over her cheek, then she continued her way.'
        },
        {
            image: 'images/blog/img-3.jpg',
            text: 'Travelling',
            title: 'Why are so many people..',
            subtext: 'Far far away, behind the word mountains, far from the countries Vokalia and Consonantia.'
        }
    ]
}

const MOCK_DATA = {
    SERVICE_DATA,
    FEATURES_DATA,
    GET_STARTED,
    WEBSITE_DESCRIPTION,
    PRICING_DATA,
    TEAM_DATA,
    TESATIMONIAL_DATA,
    BLOG_DATA
}

export default MOCK_DATA;